import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import GenericSelection from '../../../Common/GenericSelection';
import { isGFD } from '../../../../actions/root_url';

const propTypes = {
  methodSelected: PropTypes.string,
  productQuantityA: PropTypes.string,
  productQuantityB: PropTypes.string,
  discountValue: PropTypes.string,
  discountType: PropTypes.string,
  handleSelectionChange: PropTypes.func,
  handleDiscountButtonClick: PropTypes.func,
  handleTextInputChange: PropTypes.func,
};

const defaultProps = {
  methodSelected: '',
  productQuantityA: '',
  productQuantityB: '',
  discountValue: '',
  discountType: '',
  handleSelectionChange: () => {},
  handleDiscountButtonClick: () => { },
  handleTextInputChange: () => { },
};

const methodOptions = [
  { label: <Translate value="every" />, value: 'Every' },
  { label: <Translate value="each" />, value: 'Each' },
];
const BuyAGetBFields = ({
  methodSelected,
  productQuantityA,
  productQuantityB,
  discountValue,
  discountType,
  handleSelectionChange,
  handleDiscountButtonClick,
  handleTextInputChange,
  setDiscountValue,
  promotedPrice,
  setPromotedPrice,
  selectedProductB,
  calculatePromotedPrice,
  selectedProductA,
  selectedProductMixA,
  type,
}) => (
  <div className="promo-fields-b">
      <div className="method-selection">
        <GenericSelection
          translation={<Translate value="method" />}
          setSelected={({ value }) => handleSelectionChange(value, 'methodSelected')}
          value={methodSelected}
          options={methodOptions}
          colon
        />
      </div>
    {isGFD && <div className="flex-row">
      <label htmlFor="qty-label" className="field-margin"><Translate value="qty" />:</label>
      <div className="flex-row" id="buy-a-get-b-input">
        <label htmlFor="prod-qty-A" className="field-margin"><Translate value={isGFD ? '' : 'buy'} /></label>
        <div className="buy-a-get-b-input-format">
          <input
            id="qty-A-text-input"
            name="productQuantityA"
            className="text-input-field"
            type="text"
            value={productQuantityA}
            onChange={handleTextInputChange}
          />
          {/* <span>(A)</span> */}
        </div>
      </div>
    </div>  
    }
    {!isGFD && <div className="flex-row">
      <label htmlFor="qty-label" className="field-margin"><Translate value="qty" />:</label>
      <div className="flex-row" id="buy-a-get-b-input">
        <label htmlFor="prod-qty-A" className="field-margin"><Translate value={isGFD ? '' : 'buy'} /></label>
        <div className="buy-a-get-b-input-format">
          <input
            id="qty-A-text-input"
            name="productQuantityA"
            className="text-input-field"
            type="text"
            value={productQuantityA}
            onChange={handleTextInputChange}
          />
          <span>(A)</span>
        </div>
        <label htmlFor="prod-qty-B" className="field-margin"><Translate value="get" /></label>
        <div className="buy-a-get-b-input-format">
          <input
            id="qty-B-text-input"
            name="productQuantityB"
            className="text-input-field"
            type="text"
            value={productQuantityB}
            onChange={handleTextInputChange}
          />
          <span>(B)</span>
        </div>
      </div>
    </div>}
    {!isGFD && <div className="discount-field">
      <label htmlFor="discount" className="field-margin "><Translate value="discount" /> (B):</label>
      {/* <div className="discount-input-format"> */}
        <input
          id="discount-text-input"
          name="discountValue"
          className="text-input-field"
          type="text"
          value={discountValue}
          onChange={(e) => {
            handleTextInputChange(e);
            let product = selectedProductB;
            if (type === 'BuyMixAGetB') {
              product = selectedProductMixA && selectedProductMixA[0];
            }
            calculatePromotedPrice(e.target.value, product);
            // return;
            // if (discountType === 'Dollar') {
            //   let promotedPrice = "";
            //   promotedPrice = (selectedProductB.posUnitPrice - e.target.value).toFixed(2);
            //   setPromotedPrice(promotedPrice);
            // }
          }
        }
          placeholder="free"
        />
        {/* <span>(B)</span> */}
      {/* </div> */}
      <ButtonToolbar>
        <Button
          bsStyle={(discountType === 'Dollar') ? 'success' : 'null'}
          onClick={() => handleDiscountButtonClick('Dollar', selectedProductB)}
        >
          <em className="fa fa-usd" />
        </Button>
        <Button
          bsStyle={(discountType === 'Percent') ? 'success' : 'null'}
          onClick={() => handleDiscountButtonClick('Percent', selectedProductB)}
        >
          <em className="fa fa-percent" />
        </Button>
      </ButtonToolbar>
    </div>}
    {isGFD && <div className="discount-field">
      <label htmlFor="discount" className="field-margin "><Translate value="promoted_price" />:</label>
      <input
        id="discount-text-input"
        name="promotePrice"
        className="text-input-field"
        type="text"
        value={promotedPrice}
        disabled={discountType === 'Percent'}
        onChange={({ target }) => {
          let product = selectedProductB;
          if (type === 'BuyMixAGetB') {
            product = selectedProductMixA && selectedProductMixA[0];
          }
          setPromotedPrice(target.value, product);
          // setPromotedPrice(target.value);
          // // handleDiscountButtonClick('Dollar');
          // let discount = "";
          // discount = (selectedProductB.posUnitPrice - target.value).toFixed(2);
          // setDiscountValue(discount);
        }}
      />
    </div>}
  </div>
);

BuyAGetBFields.propTypes = propTypes;
BuyAGetBFields.defaultProps = defaultProps;

export default BuyAGetBFields;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/components/BuyAGetBFields.jsx